import React from 'react';
import InstructionsDF from '../components/SimulatorsComponents/DefualtSimulators/InstructionsDF';

//= ========================================================================
const Sim_V03_instructions = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
}) => (
  <InstructionsDF
    globJSON={globJSON}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_V03_instructions;
